import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import TrackingLink from '@components/trackingLink';
import Image from '@components/imgComp';

import categories from '@config/categories';
import formatDate from '@utils/formatDate';

import * as styles from './styles.module.scss';

const Recommended: FC<any> = ({ isAmp = false, content }) => {
    const { t } = useTranslation();
    return (
        <div className={styles['rec_side_bar']}>
            <span>{t('side_bars.recommended')}</span>
            {content?.side.map(({ data, uid }, index) => (
                <div key={index} className={styles['rec_card']}>
                    <TrackingLink
                        href={`/${uid}/${isAmp ? 'amp/' : ''}`}
                        tracking={{
                            event: 'Recommended Article Clicked',
                            obj: {
                                article_category: data?.category,
                                article_name: data?.title.text,
                                uid: uid,
                            },
                        }}
                    >
                        {isAmp ? (
                            <div className={styles['amp_img_wrapper']}>
                                <amp-img
                                    src={data?.hero_img?.url}
                                    alt={data?.hero_img?.alt}
                                    width={data?.hero_img?.dimensions?.width}
                                    height={data?.hero_img?.dimensions?.height}
                                    layout="responsive"
                                    style={{ objectFit: 'cover' }}
                                />
                            </div>
                        ) : (
                            <Image
                                {...data?.hero_img}
                                className={styles['img_wrapper']}
                                style={{ objectFit: 'cover' }}
                            />
                        )}
                        <div className={styles['card_content']}>
                            <span>{data?.title?.text}</span>
                            <div>
                                <span
                                    className={styles['category_tag']}
                                    style={{
                                        backgroundColor: categories[data?.category]?.color,
                                        letterSpacing: data?.category === 'leoandlea' ? -1 : 0,
                                    }}
                                >
                                    {t(`category.${data?.category}`)}
                                </span>
                                <span className={styles['post_date']}>{formatDate(data?.date)}</span>
                            </div>
                            <p>
                                {data?.body
                                    ?.filter(({ slice_type }: { slice_type: string }) => slice_type === 'content')[0]
                                    ?.primary?.text?.text.slice(0, 40)}
                                ...
                            </p>
                        </div>
                    </TrackingLink>
                </div>
            ))}
        </div>
    );
};

export default Recommended;
